export default __webpack_public_path__ + "videos/halloween-hub-landing.mp4";